import routerJS from "@/router";
import store from "../../store/index";

import myTicketsCommonService from "@/services/common/myTickets";

import demand from "@/services/nativeHandler/demand.js";

export default {
  // 未ログインのダイアログ
  returnNativeAppToAccountPage() {
    const done = this.callNativeMethod("ncErrorWeb", "E00000001");
    if (!done) {
      alert("未ログインのためネイティブへ");
    }
  },
  // リフレッシュトークン
  refreshToken() {
    const done = this.callNativeMethod("ncErrorWeb", "E00000002");
    if (!done) {
      alert("リフレッシュトークン");
    }
  },
  // クレカ未登録で、クレカ登録画面へ遷移
  returnNativeAppToCreditCardPageNothing() {
    const done = this.callNativeMethod("ncErrorWeb", "E00000003");
    if (!done) {
      alert("クレカ未登録");
    }
  },
  returnNativeAppToCreditCardPageUnknown() {
    const done = this.callNativeMethod("ncErrorWeb", "E00000013");
    if (!done) {
      alert("クレカ不備");
    }
  },
  returnNativeAppToCreditCardPageSuspended() {
    const done = this.callNativeMethod("ncErrorWeb", "E00000023");
    if (!done) {
      alert("クレカ有効期限切れ");
    }
  },
  // プロファイル未登録で、プロファイル登録画面へ遷移
  returnNativeAppToProfile() {
    const done = this.callNativeMethod("ncErrorWeb", "E00000004");
    if (!done) {
      alert("プロファイル未登録");
    }
  },
  //return ContactUs page (Inquiry)
  ncReturnNativeAppToContactUs() {
    const done = this.callNativeMethod("ncReturnNativeAppToContactUs");
    if (!done) {
      alert("return Native ContactUs page (Inquiry)");
    }
  },
  // サイドメニューを開いた状態に戻る
  returnNativeTopMenu() {
    const done = this.callNativeMethod("ncShowTop");
    if (!done) {
      alert("TOPメニューへ");
    }
  },
  // 端末時刻が不正で、ダイアログ表示
  returnNativeInvalidClientDateTime() {
    const done = this.callNativeMethod("ncErrorWeb", "E00000005");
    if (!done) {
      alert("端末時刻が不正");
    }
  },
  // トークン取得
  getTokens() {
    const done = this.callNativeMethod("ncRequestTokens");
    if (!done) {
      window.jcReturnTokens({
        idToken: this.presetIdToken,
        accessToken: this.presetAccessToken,
      });
    }
  },
  ncOpenCamera(str, masterBookId = null) {
    const message =
      masterBookId != null
        ? JSON.stringify({ str, master_book_id: masterBookId })
        : str;
    const done = this.callNativeMethod("ncOpenCamera", message);
    if (!done) {
      // 特になし
      alert("QRカメラ呼び出し" + str);
    }
  },
  openTicket(url) {
    this.callNativeMethod("ncOpenTicket", url);
  },
  openCoupon(url, isPast) {
    const json = JSON.stringify({ url, isPast });
    this.callNativeMethod("ncOpenCoupon", json);
  },
  useCoupon(url) {
    this.callNativeMethod("ncUseExternalCoupon", url);
  },
  copyCoupon(code) {
    this.callNativeMethod("ncCopyCoupon", code);
  },
  openStampBook(url, isPast) {
    const json = JSON.stringify({ url, isPast });
    this.callNativeMethod("ncOpenStampBook", json);
  },
  openPastCoupons(url) {
    this.callNativeMethod("ncOpenPastCoupon", url);
  },
  ncOpenTicketToExpress(url) {
    this.callNativeMethod("ncOpenTicketToExpress", url);
  },
  // ネイティブで電話アプリを開くため、電話番号を受け渡し
  ncCallPlace(tel) {
    if (tel == null) {
      this.callNativeMethod("ncCallPlace", "0000000000");
    } else {
      this.callNativeMethod("ncCallPlace", tel);
    }
  },
  // ネイティブのtopページに戻る
  returnNativeAppTopPage() {
    const done = this.callNativeMethod("ncCloseWeb");
    if (!done) {
      console.log("トップページへ");
      // localの場合はrouterでチケットストアに遷移
      routerJS.push({
        name: "TicketStoreIndex",
      });
    }
  },
  // 成功処理のあと、MYチケットページのネイティブがストアページで開いていたタブへ飛ぶ
  returnNativeAppMyticketPage(idParams) {
    var done;
    // チケット購入完了からのこの関数の発火では引数が入ってくるので、masterbook_idという中身があればJSON文字列に変換してネイティブコール
    if (idParams && idParams.masterbook_id) {
      done = this.callNativeMethod("ncReturnWeb", JSON.stringify(idParams));
    } else {
      done = this.callNativeMethod("ncReturnWeb");
    }
    if (!done) {
      console.log("myチケットへ", idParams);
    }
  },
  // MFITT一覧(特急券タブ)に戻る
  returnNativeAppMfittIndexPage() {
    const done = this.callNativeMethod("ncCloseWeb");
    if (!done) {
      console.log("MFITT一覧へ");
      // localの場合はrouterで一覧に遷移
      routerJS.push({
        name: "MfittIndex",
      });
    }
  },
  // MFITT共有機能
  ncOpenShare(json) {
    const done = this.callNativeMethod("ncOpenShare", json);
    if (!done) {
      console.log("ncOpenShare: ", json);
      alert("ncOpenShare");
    }
  },
  // 他タブからDBSタブのTOPに遷移する
  goToDbsTabTop() {
    const done = this.callNativeMethod("ncDbsUseTicket");
    if (!done) {
      console.log("トップページへ");
      // localの場合はrouterでDBSトップに遷移
      routerJS.push({
        name: "DbsIndex",
      });
    }
  },
  // DBSのtopページに戻る
  returnNativeDbsIndexPage() {
    const done = this.callNativeMethod("ncReturnWeb");
    if (!done) {
      console.log("トップページへ");
      // localの場合はrouterでDBSトップに遷移
      routerJS.push({
        name: "DbsIndex",
      });
    }
  },
  // DBSでネイティブページに戻る(TOP指定ではなく、WebViewを閉じるだけ)
  returnNativeDbsWithClose() {
    const done = this.callNativeMethod("ncCloseWeb");
    if (!done) {
      console.log("トップページへ");
      // localの場合はrouterでDBSトップに遷移
      routerJS.push({
        name: "DbsIndex",
      });
    }
  },
  // チケット譲渡の譲渡相手へのメール処理を行うため、情報の受け渡し関数
  ncSetTransferTicket(info) {
    const json = JSON.stringify({
      transfer_key: info.transfer_key,
      id: info.id,
      name: info.name,
      book_group_id: info.book_group_id,
    });
    const done = this.callNativeMethod("ncSetTransferTicket", json);
    if (!done) {
      alert("ncSetTransferTicket" + json);
    }
  },
  // クーポンを取得完了した際に送る関数
  ncCouponComplete(code) {
    const done = this.callNativeMethod("ncCouponComplete", code);
    if (!done) {
      alert("ncCouponComplete");
    }
  },
  // チケット購入完了時に発火 idはMasterBook
  ncBuyTicket(id, bookGroupID, book, startHour) {
    const limit = myTicketsCommonService.getDiffLimitedAtMinusStartHour(
      book.available_limited_at,
      startHour
    );
    const json = JSON.stringify({
      master_book_id: id,
      book_group_id: bookGroupID,
      use_start_time: book.available_started_at,
      use_end_time: limit,
    });
    const done = this.callNativeMethod("ncBuyTicket", json);
    if (!done) {
      alert("ncBuyTicket" + json);
    }
  },
  // パス利用開始時に発火
  ncUsePass(masterBookId, bookGroupId, pass, startHour) {
    const limit = myTicketsCommonService.getDiffLimitedAtMinusStartHour(
      pass.user_limited_at,
      startHour
    );
    const json = JSON.stringify({
      master_book_id: masterBookId,
      book_group_id: bookGroupId,
      use_start_time: pass.user_started_at,
      use_end_time: limit,
    });
    const done = this.callNativeMethod("ncUseTicket", json);
    if (!done) {
      alert("ncUseTicket" + json);
    }
  },
  // シート利用開始時に発火
  ncUseSheet(masterBookId, bookGroupId, book, startHour) {
    const limit = myTicketsCommonService.getDiffLimitedAtMinusStartHour(
      book.user_limited_at,
      startHour
    );
    const json = JSON.stringify({
      master_book_id: masterBookId,
      book_group_id: bookGroupId,
      use_start_time: book.user_started_at,
      use_end_time: limit,
    });
    const done = this.callNativeMethod("ncUseTicket", json);
    if (!done) {
      alert("ncUseTicket" + json);
    }
  },
  // アニメーションの表示時に発火
  ncMyTicketStartAnimation(type, id) {
    var json;
    if (type == "sheet") {
      json = JSON.stringify({
        master_sheet_id: id,
      });
    } else {
      json = JSON.stringify({
        master_pass_id: id,
      });
    }

    const done = this.callNativeMethod("ncMyTicketStartAnimation", json);

    if (!done) {
      // alert("ncMyTicketStartAnimation"+ json);
    }
  },
  // BookGroupの払い戻し完了時
  ncTicketRefund(bookGroupID) {
    const json = JSON.stringify({
      book_group_id: bookGroupID,
    });
    const done = this.callNativeMethod("ncTicketRefund", json);
    if (!done) {
      alert("ncTicketRefund" + json);
    }
  },
  // 画面輝度を最大にする(QR改札チケット表示時)
  ncSetBrightnessMax() {
    const done = this.callNativeMethod("ncSetBrightnessMax");
    if (!done) {
      alert("ncSetBrightnessMax");
    }
  },
  // 画面輝度を元に戻す(QR改札チケット表示終了後)
  ncRevertBrightness() {
    const done = this.callNativeMethod("ncRevertBrightness");
    if (!done) {
      alert("ncRevertBrightness");
    }
  },
  // ネイティブの現バージョンを取得
  ncAppVersion() {
    const device = store.getters["common/device"] || this.getDevice();
    store.commit("common/setDevice", device);
    switch (device) {
      case "IOS":
        // eslint-disable-next-line no-undef
        if (webkit.messageHandlers["ncAppVersion"]) {
          // eslint-disable-next-line no-undef
          webkit.messageHandlers["ncAppVersion"].postMessage("");
        } else {
          window.jcAppVersion("undefined");
        }
        return true;

      case "ANDROID":
        // eslint-disable-next-line no-undef
        if (android["ncAppVersion"]) {
          // eslint-disable-next-line no-undef
          android["ncAppVersion"]();
        } else {
          window.jcAppVersion("undefined");
        }
        return true;

      default:
        window.jcAppVersion("2.2.0");
        return false;
    }
  },
  ncSendTicketingError(page, error) {
    this.callNativeMethod(
      "ncErrorOccurred",
      JSON.stringify({
        domain: "ErrorDomainTicketing",
        error_code: 400,
        user_info: {
          page: page,
          error_message: error,
        },
      })
    );
  },
  ncSendMfittError(errorMessage) {
    this.callNativeMethod(
      "ncErrorOccurred",
      JSON.stringify({
        domain: "ErrorDomainMFIIT",
        error_code: 400,
        user_info: {
          description: errorMessage,
        },
      })
    );
  },

  // src/mixins/Common/NativeHandlerMixin.js と統合するべきか
  ncGotoPlaceDbs(location) {
    const json = JSON.stringify({
      name: location.Station.Name,
      lat: parseFloat(location.GeoPoint.lati_d),
      lng: parseFloat(location.GeoPoint.longi_d),
    });
    const done = this.callNativeMethod("ncGotoPlace", json);
    if (!done) {
      alert("経路検索ncRequest" + json);
    }
  },
  ncSetPlaceInfoDbs(location) {
    const json = JSON.stringify({
      name: location.Station.Name,
      lat: parseFloat(location.GeoPoint.lati_d),
      lng: parseFloat(location.GeoPoint.longi_d),
    });
    const done = this.callNativeMethod("ncSetPlaceInfo", json);
    if (!done) {
      // 特になし
    }
  },
  ncDbsOpenWebview(url) {
    const done = this.callNativeMethod("ncDbsOpenWebview", url);
    if (!done) {
      // 特になし
      console.log("url :>> ", url);
    }
  },
  // 基本はncDbsOpenWebview()を使用するが、詳細→QR読み取り&自転車選択へ遷移時のみ、こちらを使用する。
  ncDbsNowUseURL(url) {
    const done = this.callNativeMethod("ncDbsNowUseURL", url);
    if (!done) {
      // 特になし
      console.log("url :>> ", url);
    }
  },
  ncDbsOfficialApp(park_id) {
    const done = this.callNativeMethod("ncDbsOfficialApp", park_id);
    if (!done) {
      // 特になし
      console.log("park_id :>> ", park_id);
    }
  },
  ncOpenDbsApp(lat, lng, park_id) {
    const json = JSON.stringify({
      lat: lat,
      lng: lng,
      park_id: park_id,
    });
    const done = this.callNativeMethod("ncOpenDbsApp", json);
    if (!done) {
      // 特になし
      console.log("park_id :>> ", park_id);
    }
  },
  // 予約→利用開始で、QR読み取り
  ncDbsQrFromReserve() {
    const done = this.callNativeMethod("ncDbsQrFromReserve");
    if (!done) {
      alert("ネイティブでQR読み取り");
    }
  },
  ncDbsQrFromUsing() {
    const done = this.callNativeMethod("ncDbsQrFromUsing");
    if (!done) {
      alert("ネイティブでQR読み取り");
    }
  },

  // 周辺・カーシェア・レンタカーでページ描画完了をマップWebviewへ知らせる関数
  ncPageReady() {
    this.callNativeMethod("ncPageReady");
  },
  // src/mixins/Common/NativeHandlerMixin.js と統合するべきか

  callNativeMethod(action, message = null) {
    const device = this.getDevice();
    let postMessage;
    switch (device) {
      case "IOS":
        try {
          if (message === null) {
            postMessage = "";
          } else {
            postMessage = message;
          }
          // eslint-disable-next-line no-undef
          webkit.messageHandlers[action].postMessage(postMessage);
        } catch (err) {
          if (process.env.VUE_APP_ENV === "development") {
            alert(err);
          }
        }
        return true;
      case "ANDROID":
        try {
          if (message === null) {
            // eslint-disable-next-line no-undef
            android[action]();
          } else {
            postMessage = message;
            // eslint-disable-next-line no-undef
            android[action](postMessage);
          }
        } catch (err) {
          if (process.env.VUE_APP_ENV === "development") {
            alert(err);
          }
        }
        return true;
      default:
        return false;
    }
  },
  getDevice() {
    const ua = window.navigator.userAgent.toLowerCase();
    let device = null;
    // iOS
    if (ua.indexOf("iphone") !== -1 || ua.indexOf("ipad") !== -1) {
      device = "IOS";
      // Android
    } else if (ua.indexOf("android") !== -1) {
      device = "ANDROID";
      // Other (Error)
    } else {
      device = "BROWSER";
    }
    return device;
  },
  demand,
  //open external excoupons tab index
  ncOpenExternalCouponIndex() {
    const done = this.callNativeMethod("ncOpenExternalCouponIndex");
    if (!done) {
      alert("ncOpenExternalCouponIndex");
    }
  },
  ncPassPortExchangeCompleted() {
    const done = this.callNativeMethod("ncPassPortExchangeCompleted");
    if (!done) {
      alert("ncPassPortExchangeCompleted");
    }
  },
  ncCommonTicketGotoPayment(bookingParams) {
    console.log("ncCommonTicketGotoPayment :: ", JSON.stringify(bookingParams));
    const done = this.callNativeMethod(
      "ncCommonTicketGotoPayment",
      JSON.stringify(bookingParams)
    );
    if (!done) {
      alert("ncCommonTicketGotoPayment");
    }
  },
  ncCommonTicketZeroYenPayment(bookingParams) {
    console.log(
      "ncCommonTicketZeroYenPayment :: ",
      JSON.stringify(bookingParams)
    );
    const done = this.callNativeMethod(
      "ncCommonTicketZeroYenPayment",
      JSON.stringify(bookingParams)
    );
    if (!done) {
      alert("ncCommonTicketZeroYenPayment");
    }
  },
  ncReturnNativeAppToMFITT() {
    const done = this.callNativeMethod("ncReturnNativeAppToMFITT");
    if (!done) {
      alert("ncReturnNativeAppToMFITT");
    }
  },
  ncOpenExternalUrl(linkURL) {
    const done = this.callNativeMethod("ncOpenExternalUrl", linkURL);
    if (!done) {
      open(linkURL, "_blank");
    }
  },
};
